var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"flex justify-evenly",on:{"click":function($event){return _vm.onClick()}}},[_c('span',{staticStyle:{"padding-left":"4px"}},[_vm._v(_vm._s(_vm.displayValue))]),_c('span',{staticStyle:{"height":"30px"},attrs:{"title":_vm.$t('Edit')}},[_vm._v("🖉")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }